
import { Component, Vue, Prop } from 'vue-property-decorator';

export interface PriceListItem {
  key: string;
  price: string;
}

@Component({ name: 'PriceList', components: {} })
export default class PriceList extends Vue {
  @Prop() private list!: PriceListItem[];

  @Prop() private text!: string;

  @Prop() private title!: string;

  @Prop() private image!: string;
}
